"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCovid19DoseDto = instanceOfCovid19DoseDto;
exports.Covid19DoseDtoFromJSON = Covid19DoseDtoFromJSON;
exports.Covid19DoseDtoFromJSONTyped = Covid19DoseDtoFromJSONTyped;
exports.Covid19DoseDtoToJSON = Covid19DoseDtoToJSON;
exports.Covid19DoseDtoToJSONTyped = Covid19DoseDtoToJSONTyped;
/**
 * Check if a given object implements the Covid19DoseDto interface.
 */
function instanceOfCovid19DoseDto(value) {
    if (!('doseNumber' in value) || value['doseNumber'] === undefined)
        return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined)
        return false;
    if (!('dateAdministered' in value) || value['dateAdministered'] === undefined)
        return false;
    if (!('lotNumber' in value) || value['lotNumber'] === undefined)
        return false;
    if (!('clinicName' in value) || value['clinicName'] === undefined)
        return false;
    return true;
}
function Covid19DoseDtoFromJSON(json) {
    return Covid19DoseDtoFromJSONTyped(json, false);
}
function Covid19DoseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'doseNumber': json['doseNumber'],
        'manufacturer': json['manufacturer'],
        'dateAdministered': json['dateAdministered'],
        'lotNumber': json['lotNumber'],
        'clinicName': json['clinicName'],
    };
}
function Covid19DoseDtoToJSON(json) {
    return Covid19DoseDtoToJSONTyped(json, false);
}
function Covid19DoseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'doseNumber': value['doseNumber'],
        'manufacturer': value['manufacturer'],
        'dateAdministered': value['dateAdministered'],
        'lotNumber': value['lotNumber'],
        'clinicName': value['clinicName'],
    };
}
//# sourceMappingURL=Covid19DoseDto.js.map